import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

const Button = ({ 
    children, 
    text, 
    variant = 'primary', 
    size, 
    type = 'button', 
    onClick, 
    disabled = false, 
    style, 
    className,
    block = false,
    ...props 
}) => {
    return (
        <BootstrapButton 
            variant={variant}
            size={size}
            type={type} 
            onClick={onClick} 
            disabled={disabled}
            className={`${block ? 'w-100' : ''} ${className || ''}`} 
            style={style}
            {...props}
        >
            {children || text}
        </BootstrapButton>
    );
};

export default Button;
